<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
  }

  const ctx: BaseProps = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  }

  export let size: BaseProps['size'] = ctx.size || 'md'
  export let role: BaseProps['role'] = ctx.role || 'img'
  export let ariaLabel = 'RanobeDB'
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  viewBox="0 0 48 48"
>
  <path
    d="M0 0 C5.94 0 11.88 0 18 0 C21.3 13.2 24.6 26.4 28 40 C24.7 40 21.4 40 18 40 C15.03 28.45 12.06 16.9 9 5 C8.67 16.55 8.34 28.1 8 40 C5.36 40 2.72 40 0 40 C0 26.8 0 13.6 0 0 Z "
    fill="#BBBCCE"
    transform="translate(0,4)"
  />
  <path
    d="M0 0 C3.3 0 6.6 0 10 0 C13.3 13.2 16.6 26.4 20 40 C16.7 40 13.4 40 10 40 C6.7 26.8 3.4 13.6 0 0 Z "
    fill="#696987"
    transform="translate(19,4)"
  />
  <path
    d="M0 0 C2.64 0 5.28 0 8 0 C8 13.2 8 26.4 8 40 C5.36 40 2.72 40 0 40 C0 26.8 0 13.6 0 0 Z "
    fill="#CDCEDD"
    transform="translate(40,4)"
  />
  <path
    d="M0 0 C2.64 0 5.28 0 8 0 C8 13.2 8 26.4 8 40 C5.36 40 2.72 40 0 40 C0 26.8 0 13.6 0 0 Z "
    fill="#73739C"
    transform="translate(0,4)"
  />
</svg>
